var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8335 17.5C17.6745 17.5 19.1669 16.0076 19.1669 14.1667V6.68557C19.1672 6.67283 19.1672 6.66005 19.1669 6.64725V5.83333C19.1669 3.99238 17.6745 2.5 15.8335 2.5H4.16687C2.32592 2.5 0.833535 3.99238 0.833535 5.83333V6.64726C0.833238 6.66005 0.83324 6.67282 0.833535 6.68556V14.1667C0.833535 16.0076 2.32592 17.5 4.16687 17.5H15.8335ZM2.5002 14.1667C2.5002 15.0871 3.24639 15.8333 4.16687 15.8333H15.8335C16.754 15.8333 17.5002 15.0871 17.5002 14.1667V7.89753L11.2382 10.4023C10.4435 10.7202 9.55694 10.7202 8.76223 10.4023L2.5002 7.89753V14.1667ZM10.6192 8.85488L17.5002 6.10247V5.83333C17.5002 4.91286 16.754 4.16667 15.8335 4.16667H4.16687C3.24639 4.16667 2.5002 4.91286 2.5002 5.83333V6.10247L9.38122 8.85488C9.77857 9.01382 10.2218 9.01382 10.6192 8.85488Z",
    fill: "#667185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f8b3da67acae86fa4019fd31d167a134.svg";
export { ForwardRef as ReactComponent };